// The app templates given to a class, for its instructor (RFC-052 §5,
// byj-1wv.77), through ClassGiven as a class's files are (byj-1wv.83): each
// opened on its own page, or taken back, asked first; a template of the
// instructor's given to the class here, as GiveToClass gives it from the
// template's page. Every member sees what is given, on the class's Templates tab.
import { api, type AppTemplate, type ClassDetail } from "../api";
import { t } from "../i18n";
import { ClassGiven } from "./ClassGiven";
import { TemplateRow, templateItems } from "./TemplateParts";

/** The calls the tab makes, so a test can supply its own. */
export type ClassTemplatesApi = Pick<typeof api, "classAppTemplates" | "appTemplates" | "giveAppTemplate" | "takeAppTemplate">;

export function ClassTemplates({ cls, onCount, client = api }: {
  cls: ClassDetail;
  /** how many templates it found, for its tab's count */
  onCount?: (n: number) => void;
  client?: ClassTemplatesApi;
}) {
  return (
    <ClassGiven<AppTemplate>
      of={cls.id}
      source={{
        given: () => client.classAppTemplates(cls.id),
        // one not published yet is offered, as from its own page
        mine: async () => (await client.appTemplates()).mine,
        give: (id) => client.giveAppTemplate(id, cls.id),
        take: (id) => client.takeAppTemplate(id, cls.id),
      }}
      onCount={onCount}
      row={(x, take) => <TemplateRow key={x.id} x={x} menu={[...templateItems(x), ...take]} />}
      label={(x) => x.title || x.name}
      words={{
        take: t("templates:templateTake"),
        takeAsk: (name) => t("classes:classTemplateTakeAsk", { name, cls: cls.name }),
        givePick: t("classes:classTemplateGivePick"),
        give: t("templates:templateGive"),
        noneToGive: t("classes:classTemplateNoneToGive"),
        none: t("classes:noClassTemplates"),
        noneLead: t("classes:noClassTemplatesLead"),
      }}
      testid="class-template"
    />
  );
}
